import { useCookies } from 'react-cookie';
import jwtDecode from 'jwt-decode';

export interface PingIdentityInfo {
  name: string;
  surname: string;
  email: string;
  userId: string;
  isLoggedIn: boolean;
}

export interface PingIdentityInfoFromToken {
  given_name: string;
  family_name: string;
  email: string;
  sub?: string;
  exp: number;
}

export function usePingIdentityInfo(): PingIdentityInfo {
  const [cookies] = useCookies(['ping-token']);
  const token = cookies['ping-token'];

  if (!token) {
    return {
      name: '',
      surname: '',
      email: '',
      userId: '',
      isLoggedIn: false,
    };
  }

  const decodedToken = jwtDecode<PingIdentityInfoFromToken>(token);
  const {
    given_name: name,
    family_name: surname,
    email,
    sub,
    exp,
  } = decodedToken;

  const currentTime = Math.floor(Date.now() / 1000);
  const isLoggedIn = exp > currentTime;

  return {
    name: name || '',
    surname: surname || '',
    email: email || '',
    userId: sub || '',
    isLoggedIn,
  };
}
